import styled, { css } from "styled-components";
import { motion } from "framer-motion";

const SECTION_PADDING_TOP = "100px";

export const StyledSection = styled.section`
  background-color: white;
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 120px 48px 60px;

  // overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    width: 100vw;
    height: 293px;
    left: calc((100% - 100vw) / 2);
    top: calc(652px + ${SECTION_PADDING_TOP});
    background: #ffab95;
    filter: blur(260px);
    opacity: 0.4;
    z-index: 0;
    border-radius: 60px;
  }

  &::after {
    content: "";
    position: absolute;
    width: 1192px;
    height: 1192px;
    left: calc((100% - 1192px) / 2);
    right: calc((100% - 1192px) / 2);
    top: calc(110px + ${SECTION_PADDING_TOP});
    background-image: url(/images/backgrounds/benefits-bg.svg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    opacity: 1;
    z-index: 0;
  }

  @media ${({ theme }) => theme.media.mobile} {
    padding: 60px 0.8rem 100px;

    &::before {
      top: 765px;
      height: 874px;
      opacity: 0.7;
    }

    &::after {
      width: 978px;
      height: 978px;
      left: calc((100% - 978px) / 2);
      right: calc((100% - 978px) / 2);
      top: 716px;
    }
  }
`;

export const HeadingContainer = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: rgba(29, 29, 29, 0.85);
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;

  @media ${({ theme }) => theme.media.mobile} {
    padding: 0 19px;
  }
`;

export const HeadingLine = styled.h2`
  font-weight: 500;
  font-size: 44px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin: 0;
  color: rgba(29, 29, 29, 0.85);

  span {
    color: rgba(29, 29, 29, 0.5);
  }

  @media (max-width: 968px) {
    br {
      display: none;
    }
  }

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 28px;
    line-height: 1.3;
    letter-spacing: unset;

    br {
      display: none;
    }
  }
`;

export const AvatarGroup = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: 0 8px;
  width: 132px;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  > div {
    position: absolute;
    top: -40px;
    left: 0;
    display: inline-flex;
    align-items: center;

    & > * + * {
      margin-left: -12px;
    }

    @media ${({ theme }) => theme.media.mobile} {
      position: relative;
      top: unset;
      left: unset;
      margin: 7px 0;
      display: flex;
      justify-content: center;
    }
  }
`;

export const AvatarImage = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px white, 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
  object-fit: cover;

  @media ${({ theme }) => theme.media.mobile} {
  }
`;

export const SeparatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 0;
  margin: 20px 0;
  z-index: 2;
`;

export const SeparatorDot = styled.div`
  width: 7px;
  height: 7px;
  background-color: #3f3f3f;
  border-radius: 50%;
`;

export const SeparatorLine = styled.div`
  width: 1px;
  height: 60px;
  border-left: 1px dashed #3f3f3f;
`;

export const ContentWrapper = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-direction: column;
  align-items: center;

  @media ${({ theme }) => theme.media.mobile} {
  }
`;

export const IntroTextCard = styled.div`
  width: 664px;
  max-width: 100%;
  padding: 55px 18px 23px;
  border-radius: 24px;
  border: 1px solid rgba(29, 29, 29, 0.1);
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(63.17px);
  position: relative;
  margin-bottom: 80px;

  &::before {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 100%;
    height: 16px;
    background-image: url(/images/icons/dot-black.svg);
    background-repeat: no-repeat;
    background-size: 16px;
    background-position: center;
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    padding-left: 23px;
    padding-right: 23px;
  }
`;

export const IntroTextBox = styled.p`
  color: rgba(29, 29, 29, 0.5);
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 20px;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  margin: 0;

  strong {
    font-weight: 500;
    color: rgba(29, 29, 29, 0.85);

    &.hl {
      color: #ff6030;
    }
  }

  @media ${({ theme }) => theme.media.mobile} {
    br {
      display: none;
    }
  }
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  justify-content: center;
  width: 100%;

  @media ${({ theme }) => theme.media.mobile} {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const BenefitCardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.media.nonMobile} {
    ${({ $isMiddleCard }) =>
      $isMiddleCard
        ? css``
        : css`
            margin-top: 80px;
          `}
  }
`;

export const BenefitCard = styled(motion.div)`
  background-color: white;
  border-radius: 32px;
  padding: 100px 40px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 60px;

  @media ${({ theme }) => theme.media.mobile} {
    padding: 60px 40px 32px;
    gap: 40px;
  }
`;

export const BenefitCardInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const BenefitStatContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const BenefitStatNumber = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 100px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.02em;
  color: rgba(29, 29, 29, 0.85);

  @media (max-width: 1300px) {
    font-size: 5.5vi;
  }

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 88px;
  }
`;

export const BenefitArrowIcon = styled.img.attrs({
  src: "/images/icons/arrow-top-right.svg",
  alt: "Arrow icon",
})`
  width: 80px;
  height: 80px;

  @media (max-width: 1300px) {
    width: 5.5vi;
    height: 5.5vi;
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 80px;
    height: 80px;
  }
`;

export const BenefitTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  color: rgba(29, 29, 29, 0.85);
  margin: 0;
  white-space: nowrap;

  @media ${({ theme }) => theme.media.mobile} {
    white-space: normal;
  }
`;

export const BenefitDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: rgba(29, 29, 29, 0.5);
  margin: 0;
  width: 100%;
`;
